import { Injectable } from "@nestjs/common";
import { CreateQuestion } from "../entities/create-question";
import { CreateQuestionBankReqModel } from "@boi/shared-models";

@Injectable()
export class CreateQuestionAdapter {
    public convertDtoToEntity(dto: CreateQuestionBankReqModel, createdBy?: string): CreateQuestion {

        const question = new CreateQuestion();
        question.department = dto.classId;
        question.language = dto.language;
        question.subject = dto.subject;
        question.qno = dto.qno;

        const qTypeId = Number(dto.questionTypeMaster || (dto as any).questiontype || dto.questionType || 0);
        const complexityId = Number(dto.complexity || dto.difficultyLevel || 0);

        question.complexity = complexityId;
        question.questiontype = qTypeId;

        question.question = dto.question;
        question.preparedBy = dto.preparedBy;
        question.mobileNo = dto.mobileNo;
        question.answerKey = dto.answerKey || null;
        question.source = dto.source || null;
        question.previousAppearanceCount = Number(dto.previousAppearanceCount) || 0;
        question.approvedBy = dto.approvedBy || null;
        question.approvedDate = dto.approvedBy ? new Date() : null;

        if (createdBy) question.createdBy = createdBy;

        return question;
    }
}